window.theme = window.theme || {};
let token,url;
if (window.location.hostname.includes('ycljewels.com')) {
    token = "a971bbee06ae9006e9b78cb3e0a9c022";
    url = "https://yourcorelight.myshopify.com/api/2022-10/graphql.json";
} else {
    token = "a8a8b04733252e9b7ffa96053e1ce59e";
    url = "https://ycl-jewels.myshopify.com/api/2022-10/graphql.json";
}

theme.GraphQL = {
    config: {
        storefront_token: token,
        request_url: url
    },

    getQuery: function(item, type, handle) {
        return `{
            products(first: 100, query: "${type}:${type === 'tag' ? 'addon_': ''}${item.sku.replace(handle, '')}") {
                edges {
                  node {
                    id
                    title
                    tags
                    totalInventory
                    availableForSale
                    images(first: 1) {
                        edges {
                          node {
                            url
                          }
                        }
                    }
                    variants(first: 50) {
                      edges {
                        node {
                          id
                          title
                          quantityAvailable
                          availableForSale
                          price {
                            amount
                          }
                          image {
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }`;
    },

    sendRequest: async function(data, request_group) {

        this.config[request_group] == null ?
          this.config[request_group] = 1 :
          this.config[request_group]++;

        try {
            const response = await fetch(this.config.request_url, {
                method: 'POST',
                async: true,
                crossDomain: true,
                headers: {
                    'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                    'Content-Type': 'application/graphql'
                },
                body: data
            });

            return response.json();
        }
        catch (err) {
            console.log(err)
        }
    },

    cleanUp: function(request_group) {
        if(theme.GraphQL.config[request_group] < 1) delete this.config[request_group];
    },

    retrieveID: function(input) {
        return (input.split("/").pop());
    },

    removeBundleItem: function(keys, callback) {
        let keys_to_remove = keys.split(','),
          qty = 0,
          items_data = { updates: {} };

        for(let i=0;i<keys_to_remove.length;i++) {
            items_data.updates[keys_to_remove[i]] = qty;
        }

        return $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            data: items_data
        }).done(function(data, textStatus, jqXHR) {
            return callback(true);
        }).fail(function(jqXHR, textStatus) {
            console.log('Error - ajax update quantity', JSON.parse(jqXHR.responseText).description);
            return callback(false, JSON.parse(jqXHR.responseText).description);
        });
    },

};